<template>
  <b-navbar-item
      class="account-menu-item"
      :class="{'dropdown-is-fullwidth': windowWidth < 1024, 'reduce': reduce }">
    <b-dropdown aria-role="list"
                id="dropdown"
                :class="{'is-fullwidth': windowWidth < 1024 }"
                position="is-bottom-left"
                :mobile-modal="false">
      <a class="navbar-item"
        slot="trigger"
        slot-scope="{ active }"
        role="button">
        <avatar> {{ initials }} </avatar>
        <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
      </a>
      <b-dropdown-item v-if="windowWidth < 1024" custom>
        <account-name :classes="['has-text-left']"></account-name>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem"  v-if="isSwitched" @click="switchBack">
        Back to my account
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem" @click="logout">Logout</b-dropdown-item>
      <template v-if="contractor">
        <hr class="dropdown-divider">
        <b-dropdown-item aria-role="listitem" href="https://www.enhancify.com/service-provider-agreement" rel="nofollow" target="_blank">
          Service Provider Agreement
        </b-dropdown-item>
      </template>
    </b-dropdown>
    <b-navbar-item
      class="is-hidden-desktop"
      v-if="isSwitched"
      aria-role="menuitem"
      @click="switchBack">
      Back to my account
    </b-navbar-item>
    <b-navbar-item class="is-hidden-desktop" @click="logout">
      Logout
    </b-navbar-item>
    <template v-if="contractor">
      <hr class="dropdown-divider">
      <b-navbar-item class="is-hidden-desktop" href="https://www.enhancify.com/service-provider-agreement" rel="nofollow" target="_blank">
        Service Provider Agreement
      </b-navbar-item>
    </template>
  </b-navbar-item>
</template>

<script>
import {
  mapGetters, mapActions, mapState, mapMutations,
} from 'vuex';
import Avatar from '../Avatar.vue';
import { LOGOUT_AND_CLEAR_STATE, SWITCH_USER } from '../../store/actions';
import { SET_SPLASH } from '../../store/mutations';
import AccountName from './AccountName.vue';

export default {
  components: {
    Avatar, AccountName,
  },
  name: 'AccountMenu',
  props: {
    reduce: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(['isSwitched']),
    ...mapGetters('auth2', ['initials']),
    ...mapState('auth2', { authId: (state) => state.id }),
    ...mapState('user', {
      partnerId: (state) => state.partnerId,
      contractor: (state) => state.contractor,
    }),
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  watch: {
    reduce() {
      const dropdown = document.getElementById('dropdown');
      const dropdownMenu = dropdown.getElementsByClassName('dropdown-menu');
      if (dropdownMenu) {
        if (this.reduce) {
          dropdownMenu[0].classList.add('reduce');
        } else {
          dropdownMenu[0].classList.remove('reduce');
        }
      }
    },
  },

  methods: {
    ...mapMutations({ splash: SET_SPLASH }),
    ...mapActions({ switchUser: SWITCH_USER, logoutAndClear: LOGOUT_AND_CLEAR_STATE }),

    /**
     * Dispatch logout from system
     */
    logout() {
      this.$store.commit(SET_SPLASH, true);
      this.splash(true);
      this.logoutAndClear().then(() => {
        this.$router.replace('/login').then(() => {
          this.splash(false);
        });
      });
    },

    /**
     * Dispatch "switchBack" to auth user
     */
    switchBack() {
      this.splash(true);
      this.switchUser(this.authId)
        .then(() => this.$router.push('/'))
        .finally(() => this.splash(false));
    },
  },

};
</script>

<style lang="stylus" scoped>
.navbar-item.account-menu-item
  padding-top 0
  padding-bottom 0
  padding-left 0
.navbar-item.account-menu-item:hover
  background-color unset
  cursor unset
.account-menu
  margin-bottom 15px
  align-items flex-start
#dropdown
  cursor default
  >>>.dropdown-menu
    .dropdown-content a
      font-size 16px
    transition padding-left .3s linear
    @media screen and (max-width 1023px)
      padding-top 0
      a.dropdown-item
        font-size 16px
      padding-left 160px
      &.reduce
        padding-left 135px
    @media screen and (max-width 768px)
      &.reduce
        padding-left 0

</style>
